<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 px-0 py-2>
        <v-card flat rounded="xl" outlined>
          <v-layout pt-4 px-4 wrap justify-end>
            <v-flex xs12 sm9 md7 xl9 text-left>
              <span
                style="
                  font-family: opensansbold;
                  font-size: 25px;
                  color: #808080;
                "
              >
                Recent Orders
              </span>
            </v-flex>
            <v-flex xs6 sm3 md5 xl3 text-right align-self-center>
              <router-link to="/Seller/PendingOrders">
                <span v-if="products.length > 0"
                  style="
                    font-family: opensanslight;
                    font-size: 14px;
                    color: #041c4b;
                    cursor: pointer;
                  "
                >
                  View More...
                </span>
              </router-link>
            </v-flex>
          </v-layout>
          <v-layout pt-2 wrap justify-center v-if="products.length > 0"> 
            <v-flex xs12 px-2 py-2 v-for="(item, i) in products" :key="i">
              <v-card flat rounded="xl" color="#F5F7FC" outlined>
                <v-layout px-sm-4 wrap justify-center>
                  <v-flex xs12>
                    <v-layout wrap justify-center>
                      <v-flex xs3 lg3 xl3 pa-2>
                        <v-img
                          :src="mediaURL + item.productId.photos[0]"
                          height="100px"
                          contain
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="#FF4343"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-flex>
                      <v-flex xs9 lg9 xl9 style="line-height: 20px">
                        <v-layout wrap justify-center>
                          <v-flex xs12 text-left pt-2>
                            <router-link
                              :to="
                                '/Seller/Orders/' +
                                item.order_id +
                                '?prod=' +
                                item._id
                              "
                            >
                              <span
                                style="
                                  font-family: opensansbold;
                                  font-size: 16px;
                                  color: #808080;
                                "
                              >
                                {{ item.name.slice(0, 25) }}
                                <span v-if="item.name.length > 25"> ... </span>
                              </span>
                            </router-link>
                          </v-flex>
                          <v-flex xs12 text-left>
                            <span
                              style="
                                font-family: opensansbold;
                                font-size: 14px;
                                color: #000000;
                              "
                            >
                              Price: ₹{{ item.productTotalAmount.toFixed() }}
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left>
                            <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                                color: #000000;
                              "
                            >
                              {{item.productOrderStatus}}
                            </span>
                            <span
                              class="pl-5"
                              style="
                                font-family: opensanslight;
                                font-size: 12px;
                                color: #000000;
                              "
                            >
                              {{ formatDate(item.track_dateTime.ordered) }}
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left>
                            <span
                              style="
                                font-family: opensansregular;
                                font-size: 12px;
                                color: #188320;
                              "
                            >
                              Stock: {{ item.quantity }} Pieces
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout wrap px-4 v-else>
            <v-flex xs12 text-left pb-2>
              <span
                style="
                  font-family: opensansbold;
                  
                  color: red;
                "
              >
              <span style="font-size: 20px">0</span> <span style="font-size: 12px">Order Status Pending</span> 
              </span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      sortItems: [
        { name: "Today", value: "Today" },
        { name: "Yesterday", value: "Yesterday" },
        { name: "This Week", value: "This Week" },
      ],
      sortItem: "Today",
      products: [],
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "seller/ordered/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productOrderStatus: "ordered",
          page: 1,
          limit: 5,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            // console.log("products",this.products)
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>